import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { APP_URL } from "@/lib/constants";
import { trackEvent } from "@/lib/analytics";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 3.45);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-cta"
      onClick={() => trackEvent("app_click", { location: "sticky_cta" })}
      className="fixed z-40 bottom-5 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-8 flex items-center gap-3 px-6 py-[14px] rounded-full font-semibold text-[15px] whitespace-nowrap transition-opacity duration-500"
      style={{
        background: "var(--ink)",
        color: "#ffffff",
        border: "1px solid rgba(255,171,0,0.45)",
        boxShadow: "0 10px 34px rgba(6,4,10,0.4)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <Gift size={18} style={{ color: "var(--accent)" }} />
      Получить 10 000 ₸
    </a>
  );
};
